import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum ChartOfAccountsTemplatesViewColumn {
    NAME = "name",
    BASIS = "basis",
    INDUSTRY = "industry",
    ENTITY_TYPE = "entityType",
    CHART = "chart",
    DESCRIPTION = "description",
    ENTITIES = "entities",
    STATUS = "status",
    ACTIONS = "actions",
}

const makeColumnSchema = (id: ChartOfAccountsTemplatesViewColumn) =>
    ColumnSchema.extend({ id: z.literal(id) });

export const ChartOfAccountsTemplatesViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.CHART_OF_ACCOUNTS_TEMPLATES),
    columns: z.array(
        z.discriminatedUnion("id", [
            makeColumnSchema(ChartOfAccountsTemplatesViewColumn.NAME),
            makeColumnSchema(ChartOfAccountsTemplatesViewColumn.BASIS),
            makeColumnSchema(ChartOfAccountsTemplatesViewColumn.INDUSTRY),
            makeColumnSchema(ChartOfAccountsTemplatesViewColumn.ENTITY_TYPE),
            makeColumnSchema(ChartOfAccountsTemplatesViewColumn.CHART),
            makeColumnSchema(ChartOfAccountsTemplatesViewColumn.DESCRIPTION),
            makeColumnSchema(ChartOfAccountsTemplatesViewColumn.ENTITIES),
            makeColumnSchema(ChartOfAccountsTemplatesViewColumn.STATUS),
            makeColumnSchema(ChartOfAccountsTemplatesViewColumn.ACTIONS),
        ]),
    ),
});

export type ChartOfAccountsTemplatesView = z.infer<
    typeof ChartOfAccountsTemplatesViewSchema
>;
